import { Create, useRedirect, useRefresh } from "react-admin";
import { useNotification } from "../../../common/hooks/useNotification";
import { useQueryParams } from "../../../common/hooks/useQueryParams";
import { EventMasterForm } from "./EventMasterForm";
import { EventMasterFormActions } from "./EventMasterFormActions";

interface Props {}

export const CreateEvent = (props: Props) => {
  const notify = useNotification(props, "createSuccess");
  const redirect = useRedirect();
  const refresh = useRefresh();
  const params = useQueryParams();
  const source = JSON.parse(params.get("source") ?? "{}");
  const driverId = source.driverId;
  const date = source.date;

  const handleSuccess = (args: any) => {
    notify(args);
    redirect(`/hos-driver-log-view/${driverId}/${date}`);
    refresh();
  };

  return (
    <Create
      {...props}
      actions={<EventMasterFormActions />}
      onSuccess={handleSuccess}
      title="Add a status event"
    >
      <EventMasterForm />
    </Create>
  );
};
